import { prescribeContract, prescriptionContract } from '@montugroup/prescription-contracts';

import settings from '@/data/constants';
import { createQueryClient } from '../queryClient.util';

// @todo upgrade to new Xapi contracts
export const prescribedProductClient = createQueryClient({ contract: prescriptionContract, baseUrl: settings.url });
export const prescribeClient = createQueryClient({ contract: prescribeContract, baseUrl: settings.url });
